module.exports = __webpack_public_path__ + "img/tech8.b6391cc4.webp";